export const REQUEST_TOO_LARGE_MESSAGE = 'O envio excede o tamanho máximo permitido. Divida as remessas em mais de um envio.';

export interface SubmissionErrors {
    // Mensagem principal para o alerta geral
    message: string;
    // Mensagens por índice da remessa no lote (chaves "items[i].campo")
    byItem: Record<number, string[]>;
    // Mensagens sem item associado
    general: string[];
}

const ITEM_KEY = /items\[(\d+)\]/i;
const KEY_FIELDS = ['propertyName', 'property', 'field', 'key', 'code', 'memberName'];
const MESSAGE_FIELDS = ['message', 'errorMessage', 'description', 'detail'];

function pick(obj: Record<string, any>, fields: string[]): string | undefined {
    const entry = Object.entries(obj).find(([name, value]) => fields.includes(name.charAt(0).toLowerCase() + name.slice(1)) && typeof value === 'string');
    return entry?.[1];
}

// Percorre o corpo do erro e junta pares (chave, mensagem), seja em listas de ErrorMessage
// ({ message, code/propertyName }) ou no dicionário "errors" do ValidationProblemDetails
function collect(node: any, pairs: { key?: string; message: string }[], depth = 0) {
    if (!node || depth > 5) return;
    if (Array.isArray(node)) {
        node.forEach((child) => collect(child, pairs, depth + 1));
        return;
    }
    if (typeof node !== 'object') return;

    const message = pick(node, MESSAGE_FIELDS);
    const key = pick(node, KEY_FIELDS);
    if (message && key) pairs.push({ key, message });

    Object.entries(node).forEach(([name, value]) => {
        if (ITEM_KEY.test(name) && Array.isArray(value)) {
            value.filter((v) => typeof v === 'string').forEach((v) => pairs.push({ key: name, message: v }));
        } else if (typeof value === 'object') {
            collect(value, pairs, depth + 1);
        }
    });
}

// Interpreta o erro do envio: 413 vira mensagem fixa; erros com "items[i]" são atribuídos à remessa i
export function mapSubmissionErrors(error: any): SubmissionErrors {
    const response = error?.originalError?.response;
    if (response?.status === 413) return { message: REQUEST_TOO_LARGE_MESSAGE, byItem: {}, general: [REQUEST_TOO_LARGE_MESSAGE] };

    const pairs: { key?: string; message: string }[] = [];
    collect(response?.data, pairs);

    const byItem: Record<number, string[]> = {};
    const general: string[] = [];
    pairs.forEach(({ key, message }) => {
        const match = key ? ITEM_KEY.exec(key) : null;
        if (match) {
            const index = Number(match[1]);
            byItem[index] = Array.from(new Set([...(byItem[index] ?? []), message]));
        } else if (!general.includes(message)) {
            general.push(message);
        }
    });

    const message = error?.message || 'Não foi possível enviar a remessa';
    if (general.length === 0 && Object.keys(byItem).length === 0) general.push(message);
    return { message, byItem, general };
}
